
import womenCopy from '~/content/women'

export default {
  auth: false,
  layout: 'women',
  computed: {
    copy () { return womenCopy[this.$i18n.locale] || womenCopy.pl },
    joinPath () { return this.localePath(this.$auth.user ? '/users' : '/register') },
    cta () { return this.$auth.user ? this.copy.memberCta : this.copy.cta }
  },
  head () {
    const url = 'https://jaty.pl' + this.localePath('/dla-kobiet')
    return {
      title: this.copy.title,
      titleTemplate: null,
      meta: [
        { hid: 'description', name: 'description', content: this.copy.description },
        { hid: 'og:title', property: 'og:title', content: this.copy.title },
        { hid: 'og:description', property: 'og:description', content: this.copy.description },
        { hid: 'og:url', property: 'og:url', content: url },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:image', property: 'og:image', content: 'https://jaty.pl/images/dla-kobiet/together-960.jpg' },
        { hid: 'og:image:alt', property: 'og:image:alt', content: this.copy.chapters[2].alt }
      ]
    }
  },
  mounted () {
    // The full story stays visible without JavaScript and with reduced motion.
    if (!window.IntersectionObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    this.revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('women-revealed')
          this.revealObserver.unobserve(entry.target)
        }
      })
    }, { threshold: 0.12 })
    this.$el.querySelectorAll('[data-reveal]').forEach(element => this.revealObserver.observe(element))
  },
  beforeDestroy () {
    if (this.revealObserver) this.revealObserver.disconnect()
  }
}
